import {useFormik} from 'formik'
import React, {useState} from 'react'
import * as Yup from 'yup'
import {updateStatusRepromaterijala} from '../../api'
import notifyToast from '../Toast/Toast'
import StatusRolneDropdown from '../StatusDropdown/StatusRolneDropdown'
import clsx from 'clsx'
import AktivniProjektiDropdown from '../../components/Predrezervacije/AktivniProjektiDropdown'

const StatusComponent = ({rowSelection, updatePage, redesigned = false}) => {
  const [loading, setLoading] = useState(false)

  const initialValues = {
    IdPredrezervacije: '',
    RezNapomene: '',
    status: '',
    Materijali: {}, // { ReprMatId: unetaKolicina }
  }

  const validationSchema = Yup.object({
    //IdPredrezervacije: Yup.number().required('Obavezno polje'),
    //status: Yup.string().required('Obavezno polje'),
  })

  const formik = useFormik({
    initialValues,
    //validationSchema,
    onSubmit: async (values, {resetForm}) => {
      setLoading(true)

      // Build Materijali array (only if status == 3)
      const Materijali =
        values.status === '3'
          ? rowSelection.map((item) => ({
              ReprMatId: item.ReprMatId,
              ReprMatTrenutnaKolicina: item.ReprMatTrenutnaKolicina,
              unetaKolicina: values.Materijali[item.ReprMatId] || item.ReprMatTrenutnaKolicina,
            }))
          : []

      const stavkaId = rowSelection.map((item) => item.ReprMatId)

      const params = {
        status: values.status,
        IdProjekta: values.IdPredrezervacije,
        RezNapomene: values.RezNapomene,
        Materijali,
        stavkaId, // ✅ always required
      }

      try {
        const response = await updateStatusRepromaterijala(params)

        if (response.error === 0) {
          notifyToast(true, response.message + ' Vaša izmjena statusa je dodatno evidentirana')
          updatePage()
          resetForm()
        } else {
          notifyToast(false, response.message)
          updatePage()
          resetForm()
        }
      } catch (error: any) {
        notifyToast(false, error.message || 'Greška.')
      } finally {
        setLoading(false)
      }
    },
  })

  const handleKolicinaChange = (id, value) => {
    formik.setFieldValue('Materijali', {
      ...formik.values.Materijali,
      [id]: value,
    })
  }

  return (
    <form onSubmit={formik.handleSubmit} noValidate className='form'>
      <div className={redesigned ? 'row g-4 align-items-end' : 'row'}>
        <div className={redesigned ? 'col-12 col-md-8 col-xl-6' : 'col-lg-8 mb-3'}>
          {redesigned && <div className='form-label fw-semibold'>Novi status</div>}
          <StatusRolneDropdown
            value={formik.values.status}
            onChange={(name, value) => formik.setFieldValue('status', value)}
            selectName='Status'
          />
        </div>
        <div className={redesigned ? 'col-12 col-md-4 col-xl-3' : 'col-lg-4 fv-row'}>
          <button
            className={redesigned ? 'btn btn-light-primary w-100' : 'btn btn-block btn-primary'}
            type='submit'
            disabled={!rowSelection.length || !formik.isValid || loading}
          >
            <i className='bi bi-check fs-2'></i>
            {redesigned && 'Potvrdi'}
          </button>
        </div>

        {formik.values.status === '3' && (
          <div
            className={
              redesigned ? 'col-12 bg-light-primary rounded p-5 mt-5' : 'alert alert-primary'
            }
          >
            <div className='row mt-2'>
              <div className='col-12'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  Aktivni Projekti
                </label>
                <AktivniProjektiDropdown
                  value={formik.values.IdPredrezervacije}
                  onChange={(name, value) => formik.setFieldValue('IdPredrezervacije', value)}
                  errors={formik.errors.IdPredrezervacije}
                  touched={formik.touched.IdPredrezervacije}
                  selectName='IdPredrezervacije'
                />
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-12'>
                <div className={redesigned ? 'fw-semibold fs-7 text-gray-700' : 'fw-bold fs-2'}>
                  Ukoliko ne upišete količinu, količina = trenutnoj težini rolne.
                </div>
                {rowSelection.map((item) => (
                  <div key={item.ReprMatId} className='row mt-5 mb-2'>
                    <div className='col-lg-3'>
                      <strong>ID:</strong> {item.ReprMatId}
                    </div>
                    <div className='col-lg-3'>
                      <strong>Trenutna količina:</strong> {item.ReprMatTrenutnaKolicina}
                    </div>
                    <div className='col-lg-6'>
                      <input
                        type='number'
                        placeholder='Unesite količinu'
                        value={formik.values.Materijali[item.ReprMatId] || ''}
                        onChange={(e) => handleKolicinaChange(item.ReprMatId, e.target.value)}
                        className='form-control form-control-lg form-control-solid'
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className='row mt-3'>
              <label className='col-lg-10 col-form-label fw-bold fs-6'>Napomena</label>
              <div className='col-lg-12 fv-row'>
                <textarea
                  placeholder='Napomena'
                  {...formik.getFieldProps('RezNapomene')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.RezNapomene && formik.errors.RezNapomene,
                    },
                    {
                      'is-valid': formik.touched.RezNapomene && !formik.errors.RezNapomene,
                    }
                  )}
                />
                {formik.touched.RezNapomene && formik.errors.RezNapomene && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.RezNapomene}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </form>
  )
}

export default StatusComponent
